const APOSTROPHES = /['’ʻʼ`´]/g;
const COMBINING_MARKS = /[\u0300-\u036f]/g;
const NON_LETTER_OR_NUMBER = /[^\p{L}\p{N}]+/gu;

export const normalizeTurkishSearchText = (value) => String(value ?? '')
  .toLocaleLowerCase('tr-TR')
  .replace(/ı/g, 'i')
  .normalize('NFD')
  .replace(COMBINING_MARKS, '')
  .replace(APOSTROPHES, '')
  .replace(NON_LETTER_OR_NUMBER, ' ')
  .trim()
  .replace(/\s+/g, ' ');

export const matchesTurkishSearch = (value, query) => {
  const normalizedQuery = normalizeTurkishSearchText(query);
  if (!normalizedQuery) return true;

  const normalizedValue = normalizeTurkishSearchText(value);
  if (!normalizedValue) return false;

  return normalizedQuery
    .split(' ')
    .every((token) => normalizedValue.includes(token));
};
